



















































import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    recipients: {
      type: Array as PropType<Recipient[]>,
      default: () => [],
    },
    newCommentsCount: {
      type: Number,
      default: 0,
    },
    chatEnabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const handleOpenRecipients = () => {
      emit('recipients');
    };

    const handleToggleChat = () => {
      emit('chat');
    };

    const handleToggleMenu = () => {
      emit('menu');
    };

    const newChatComments = computed(() => props.newCommentsCount > 0);

    const handleHelp = () => {
      window.open('http://help.getaccept.com/en/articles/4175027', '_blank');
    };

    return {
      handleOpenRecipients,
      handleToggleChat,
      handleToggleMenu,
      newChatComments,
      handleHelp,
    };
  },
});
